import { Component, Prop, Vue } from "vue-property-decorator";
import { downloadApps } from "@/utils/app_download";
import { sendEvent } from "@/utils/log_event";
import AutoPaymentCache from "@/services/super_pay/auto_payment_cache";
import SwitchBackgroundPosition, {
  SwitchPositionTypes
} from "@/utils/switch_background/switch_background_position";
import { UIA_SP_CLICK } from "@/utils/log_event/event_const.ts";

@Component
class SuperPayButton extends Vue {
  @Prop()
  private ctx: any;
  @Prop()
  private padding: any;
  @Prop()
  private item: any;
  @Prop()
  private place: any;
  @Prop()
  private click_point_key: any;
  @Prop()
  private dialog_class: any;
  @Prop()
  private offer: any;

  private buttonDefaultStyle =
    "background:rgb(41,161,247);font-family:Avenir-Heavy;color:#fff;padding:9px 0;text-align:center;line-height:26px;font-size:16px;border-radius:8px;";

  public render() {
    // 开机需要padding，支付页不需要
    const buttonStyle = this.padding
      ? "margin:0 32px;" + this.buttonDefaultStyle
      : this.buttonDefaultStyle;
    return (
      <div
        onClick={async () => {
          if (!this.offer) {
            this.ctx.isShow = false;
          }
          AutoPaymentCache.set({
            offer: this.offer,
            pay_way: "back_up"
          });
          downloadApps(this.item);
          SwitchBackgroundPosition.setPosition(
            this.dialog_class === "back_up"
              ? SwitchPositionTypes.REFRESH_CG_USER_INFO
              : SwitchPositionTypes.NOT_REQUIRE_REFRESH
          );
          const videoUrl = this.item.video_url || this.item.videoUrl;
          const videoPathList = videoUrl.split("/");
          const videoName = videoPathList[videoPathList.length - 1];
          this.dialog_class === "super_pay" &&
          sendEvent(UIA_SP_CLICK, {
            promo_video: videoName,
            situation: "payment_choice",
            style: "alert",
            action: "get"
          });
        }}
        style={buttonStyle}
      >
        GET
      </div>
    );
  }
}
export default SuperPayButton;
